import Swiper from "swiper/bundle";

const bigSliderContainers = document.querySelectorAll('.realization-big-slider')
let bigSliders = []

const isLastBullet = (index, total, className) => {
  return index + 1 == total ? className + '-last-bullet' : '';
}

bigSliderContainers
  .forEach((element, index) => {
    const resistance = (element.querySelector('.realization-big-slider__swiper-container').dataset.resistance)
    bigSliders.push(new Swiper(element.querySelector('.realization-big-slider__swiper-container'), {
      slidesPerView: 1,
      pagination: {
        el: element.querySelector('.swiper-pagination'),
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + ' ' + isLastBullet(index, element.querySelectorAll('.swiper-slide').length, className) + '">' + (index + 1) + '</span>';
        },
      },
      navigation: {
        nextEl: element.querySelector('.swiper-button-next'),
        prevEl: element.querySelector('.swiper-button-prev'),
      },
      resistanceRatio: resistance === '0' ? 0 : 0.85
    }))
  })
